// src/components/ErrorBoundary/ErrorBoundary.js
import React from 'react';
import ErrorModal from './modalError'; // Asegúrate de importar correctamente según tu estructura

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      hasError: false, 
      errorInfo: null,
      isModalOpen: false
    };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      hasError: true,
      error: error,
      errorInfo: errorInfo,
      isModalOpen: true
    });
    console.error("Error capturado en boundary:", error, errorInfo);
  }

  handleCloseModal = () => {
    this.setState({ isModalOpen: false });
  }

  handleRetry = () => {
    this.setState({ hasError: false, isModalOpen: false });
    // Opcional: recargar la página o realizar alguna acción de reinicio
    // window.location.reload();
  }

  render() {
    if (this.state.hasError) {
      return (
        <>
          <ErrorModal 
            isOpen={this.state.isModalOpen}
            setIsOpen={this.handleCloseModal}
            onRetry={this.handleRetry}
          />
          <div>Error encontrado. Por favor, intente nuevamente.</div>
        </>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;